import { checkIsStoryBookPath } from 'app/utils/check-is-story-book-path';

export const URI_PREFIX = 'trends';
export const URI_HASHTAG_PREFIX = checkIsStoryBookPath('hashtags');

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const apiRoutes = () => {
  const moduleName = window.location.pathname.split('/')?.[1];
  const isTrendModule = moduleName === 'trends';
  const GENERATE_URI = isTrendModule
    ? `${URI_PREFIX}/${URI_HASHTAG_PREFIX}`
    : URI_PREFIX;
  return {
    // HASHTAGS
    allHashtags: `${URI_PREFIX}/hashtags`,
    bulkRegrab: `${URI_PREFIX}/hashtags/resync`,

    tendsNews: `${URI_PREFIX}/news/categories`,
    newCountriesByCordinates: `${GENERATE_URI}/countries/by-coordinates`,

    // VIDEOS
    videosGainedSubs: `${URI_PREFIX}/videos/subscriber-chart`,
    videosChannelTrust: `${URI_PREFIX}/videos/trust-chart`,
    videosEngagement: `${URI_PREFIX}/videos/engagement-chart`,
    videosViewChart: `${URI_PREFIX}/videos/view-chart`,
    videosSubscribeChart: `${URI_PREFIX}/videos/subscriber-chart`,
    resyncVideo: `${URI_PREFIX}/videos/resync-videos`,
    resyncVideos: `${URI_PREFIX}/videos/regrab-trending-videos`,

    // TOPICS
    allTopics: `${URI_PREFIX}/topics`,
    topicsCountryDetails: `${URI_PREFIX}/topics/country-details`,
    getRecentNews: `${URI_PREFIX}/topics/recent-news`,
    getMostViewVideos: `${URI_PREFIX}/topics/most-view-videos`,
    getTopHashtags: `${URI_PREFIX}/topics/top-hashtags`,
    loadTopicView: `${URI_PREFIX}/topics/show/details`,

    // COMPARE TOPICS
    interesetOverTime: `${URI_PREFIX}/topics/interest-over-time`,
    mentionsOverTime: `${URI_PREFIX}/topics/mentions-over-time`,
    topicsContries: `${URI_PREFIX}/topics/countries`,
    topicsVideoView: `${URI_PREFIX}/topics/video-views`,
    topicsMentionHashtags: `${URI_PREFIX}/topics/mention-hashtags`,
    topicsSearchCount: `${URI_PREFIX}/topics/search-count`,

    // NEWS
    allNews: `${URI_PREFIX}/news`,
    getNewsArticleDetails: `${URI_PREFIX}/news/show`,
    newsCountries: `${URI_PREFIX}/news/countries`,

    // AUTOCOMPLETE
    newsAutoComplete: `${GENERATE_URI}/news`,
    videosAutoComplete: `${GENERATE_URI}/videos`,
    hashtagsAutoComplete: `${GENERATE_URI}/trending`,
    topicsAutoComplete: `${GENERATE_URI}/topics`,

    sources: `${URI_PREFIX}/sources`,

    //DASHBOARD
    topCountries: `${URI_PREFIX}/dashboard/countries-map`,

    // trends hashtag
    allUnUnnecessary: `${GENERATE_URI}/all-unnecessary`,

    TrendingHashtagAutoComplete: `${GENERATE_URI}/trending`,
    LongestHashtagAutoComplete: `${GENERATE_URI}/longest`,
    MostHashtagAutoComplete: `${GENERATE_URI}/most-mentioned`,
    UnnecessaryHashtagAutoComplete: `${GENERATE_URI}/unnecessary`,
    sentimentAnalysis: `${GENERATE_URI}/compare/sentiment-analysis`,

    // Trending 24
    trendingCompareTwentyFour: `${GENERATE_URI}/trending-twenty-four`,
  };
};
